module.exports = __webpack_public_path__ + "media/images/pepsi-west-new-c69561795501376ebf3dc670216c16b3.png";